<div class="modal">
  <div class="modal-header modal-header--black-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle
       [class.modal-header--red-background]="signError"
  >
    <div class="title">Подписание документа</div>
    <div class="close" (click)="close()">
      <i class="icon-plus"></i>
    </div>
  </div>
  <div class="modal-body modal-body--center">
    <ng-container *ngIf="isShowSignComponent && !isSignedFile">
      <ng-container *ngIf="signError; else warning">
        <div class="sub-text error">
          {{signError}}
        </div>
      </ng-container>
      <ng-template #warning>
        <div class="sub-text">
          Подпишите документ с помощью ЭЦП
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="!isShowSignComponent">
      <div class="main-text">
        Формирование pdf документа <br> для подписи
      </div>
      <div class="sub-text">
        Ожидайте... <br> Ваш документ формируется
      </div>

      <div class="progressbar">
        <div class="progressbar-wrapper">
          <div class="progressbar-inner" [style.width]="completePercent + '%'"></div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="isSignedFile">
      <ng-container *ngIf="data?.signType === 'mio_sample_ecp'; else otherTypes">
        <div class="main-text main-text--height-100px">
          <!--Образец подписи ЭЦП успешно создан-->
          Файл согласия заказчика проекта сформирован
        </div>
      </ng-container>
      <ng-template #otherTypes>
        <div class="image">
          <img src="./assets/images/icons/adobe-pdf-icon.svg" alt="Adobe reader icon">
        </div>
        <div class="main-text main-text--height-100px">
          PDF документ сформирован
        </div>
      </ng-template>
    </ng-container>


  </div>
  <div class="modal-footer modal-footer--border-top" *ngIf="isSignedFile">
    <div *ngIf="data?.signType === 'mio_consent_file'" class="btn btn-apply" matRipple
         (click)="downloadSignedMioConsentFile()"> Скачать</div>
    <div class="btn btn-cancel" matRipple (click)="close()"> ОК</div>
  </div>
</div>
